import { render } from "./EnbSuggestion.vue?vue&type=template&id=eb2a4b8e&scoped=true"
import script from "./EnbSuggestion.vue?vue&type=script&lang=js"
export * from "./EnbSuggestion.vue?vue&type=script&lang=js"

import "./EnbSuggestion.vue?vue&type=style&index=0&id=eb2a4b8e&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eb2a4b8e"]])

export default __exports__